import {
  Alert,
  Box,
  Card,
  Chip,
  CircularProgress,
  Slide,
  Snackbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { VerticalTab } from "../../components/VerticalTabs";
import { ReactComponent as ClientIcon } from "../../assets/svg/project/client.svg";
import { ReactComponent as AssignTimeIcon } from "../../assets/svg/project/assign-time.svg";
import { ReactComponent as BriefingIcon } from "../../assets/svg/project/briefing.svg";
import { ReactComponent as EventIcon } from "../../assets/svg/project/event-data.svg";
import { ReactComponent as PrevisionIcon } from "../../assets/svg/project/prevision.svg";
import ProjectClient, { ProjectClientHandle } from "./templates/ProjectClient";
import ProjectBriefing from "./templates/ProjectBriefing";
import ProjectAssignTime, { ProjectAssignTimeHandle } from "./templates/ProjectAssignTime";
import ProjectEvent from "./templates/ProjectEvent";
import ProjectFinance from "./templates/ProjectFinance";
import { useProject } from "../../contexts/project.context";
import ProjectStatusModal from "./templates/ProjectStatusModal";
import { FaCarSide } from "react-icons/fa";

const ProjectStep = () => {
  const {
    loadingProject,
    pendingManagementFields,
    registrationStep,
    clearRegistrationStep,
  } = useProject();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const projectId = searchParams.get("projectId");
  const targetSubTab = searchParams.get("subTab");
  
  // Inicializa com a sub-aba correta se vier o parâmetro
  const [optionActive, setOptionActive] = useState(() => {
    const subTab = new URLSearchParams(window.location.search).get("subTab");
    console.log('[ProjectStep] Inicializando com subTab:', subTab);
    return subTab === "event" ? 2 : 0;
  });
  
  const [showUpdateStatus, setShowUpdateStatus] = useState(false);

  const clientRef = useRef<ProjectClientHandle>(null);
  const assignTimeRef = useRef<ProjectAssignTimeHandle>(null);
  
  // Observa mudanças no parâmetro da URL
  useEffect(() => {
    const subTab = new URLSearchParams(location.search).get("subTab");
    console.log('[ProjectStep] useEffect disparado - subTab:', subTab, 'optionActive atual:', optionActive);
    
    if (subTab === "event" && optionActive !== 2) {
      console.log('[ProjectStep] Mudando para sub-aba 2 (Dados do Evento)');
      setOptionActive(2);
      
      // Limpa o parâmetro após usar
      setTimeout(() => {
        const params = new URLSearchParams(location.search);
        params.delete("subTab");
        const newUrl = params.toString() 
          ? `${window.location.pathname}?${params.toString()}`
          : window.location.pathname;
        window.history.replaceState({}, '', newUrl);
        console.log('[ProjectStep] Parâmetro subTab removido da URL');
      }, 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]); // Dispara quando a URL muda

  // "Ir para Dados Cadastrais" do bloqueio de status: abre Dados do Evento,
  // onde ficam os Campos Gerenciais pendentes.
  useEffect(() => {
    if (pendingManagementFields.length > 0) setOptionActive(2);
  }, [pendingManagementFields]);

  // Links "Editar" / "Dados cadastrais" / "Editar time" da aba Overview.
  useEffect(() => {
    if (registrationStep === null) return;
    setOptionActive(registrationStep);
    clearRegistrationStep();
  }, [registrationStep, clearRegistrationStep]);

  function handleTabClick(index: number) {
    // Permite navegação direta se for via parâmetro da URL
    const params = new URLSearchParams(location.search);
    const isFromUrlParam = params.get("subTab") === "event" && index === 2;
    
    if (isFromUrlParam) {
      setOptionActive(index);
      // Remove o parâmetro após usar para não interferir na navegação normal
      params.delete("subTab");
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState({}, '', newUrl);
      return;
    }
    
    if (index <= optionActive) {
      setOptionActive(index);
      return;
    }
    if (optionActive === 0) {
      const valid = clientRef.current?.validate() ?? true;
      if (!valid) return;
    }
    if (optionActive === 1) {
      const valid = assignTimeRef.current?.validate() ?? true;
      if (!valid) return;
    }
    setOptionActive(index);
  }

  const options = [
    {
      title: "Cliente",
      description: "Adicione o cliente",
      icon: <ClientIcon />,
      template: <ProjectClient ref={clientRef} onNext={() => setOptionActive(1)} />,
    },
    {
      title: "Atribuir time",
      description: "Adicione as células",
      icon: <AssignTimeIcon />,
      template: <ProjectAssignTime ref={assignTimeRef} onNext={() => setOptionActive(2)} onBack={() => setOptionActive(0)} />,
    },
    {
      title: "Dados do evento",
      description: "Adicione o tipo e nome do evento",
      icon: <EventIcon />,
      template: <ProjectEvent onBack={() => setOptionActive(1)} />,
    },
    // {
    //   title: "Previsão de custo e financeiro",
    //   description: "Adicione taxas, lucros e faturamento",
    //   icon: <PrevisionIcon />,
    //   template: <ProjectFinance />,
    // },
  ];


  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      pt={2}
      pb={4}
      bgcolor={"#F9FCFF"}
      flex={1}
      width={'100%'}
      overflow='auto'
    >
      

      {loadingProject && (
        <Box
          display={"flex"}
          width={"100%"}
          alignItems={"center"}
          justifyContent={"center"}
          gap={2}
          py={10}
          mt={10}
        >
          <Typography variant={"h6"}>Carregando...</Typography>
          <CircularProgress />
        </Box>
      )}

      <Card
        sx={{
          display: "flex",
          mt: 1,
          mx: 5,
          boxShadow: "0px 4px 18px 0px #4B465C1A",
          maxWidth: 1480,
        }}
      >
        {!loadingProject && (
          <>
            <VerticalTab.Root>
              {options.map(({ title, description, icon }, index) => (
                <VerticalTab.Item
                  key={index}
                  onClick={() => handleTabClick(index)}
                >
                  <VerticalTab.Icon
                    icon={icon}
                    isActive={optionActive === index}
                  />
                  <VerticalTab.Content
                    title={title}
                    description={description}
                  />
                </VerticalTab.Item>
              ))}
            </VerticalTab.Root>

            {options[optionActive].template}
          </>
        )}
      </Card>
    </Box>
  );
};

export default ProjectStep;
